// Add slide on click classes on scroll class
jQuery(document).ready(function ($) {
    var scrollOn = $('.submenu-section');
    $('.right-header .tel').on('click', function() {
        $(this).toggleClass('active');
        $(scrollOn).toggleClass('active-menu');
    });

    if($('.submenu-section').length ) {
        // Add back to top li 
        var li = document.createElement('li');
        li.className = 'back-up menu-item';
        var link = document.createElement('a');
        link.href = "#header";
        li.appendChild(link);

        document.querySelector('.submenu-section .menu').appendChild(li);
    }
});
//# sourceMappingURL=submenu-scroll-function.js.map
